export const COLUMNS_ENUM = Object.freeze({
  PREFIX: { order: 0, name: "Prefix" },
  DISPLAYED: { order: 1, name: "Displayed" },
});
